import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column, List, Icon } from '@pella/sash-framework';
import { Image, CTA } from '../../../../../';
import { isValidArray } from '../../../../../utilities/validations';

const ProMenu = ({ data, ...other }) => (
	<div
		className='proMenu max-h-[calc(100vh-150px)] overflow-auto bg-neutral-25 py-9'
		aria-label='Sub Navigation'
		{...other}
	>
		<Container>
			<Row className='xl:-mx-16 xl:[&>*]:px-16'>
				{data.category
					?.find((cat) => cat.category_type === 'feature')
					?.group?.map((feat, index) => (
						<Column
							key={index}
							lg='fluid'
							className='flex flex-col flex-wrap'
						>
							{feat.file?.url && (
								<Image
									data={{ image: feat.file }}
									className='!block h-[200px] w-full object-cover'
								/>
							)}

							{feat.heading && <p className='mt-5 text-lg font-semibold [&_a]:decoration-transparent [&_a]:decoration-1 [&_a]:hover:text-neutral-600 [&_a]:hover:decoration-current'>{feat.cta.length === 1 ? <CTA data={feat.cta[0]}>{feat.heading}</CTA> : feat.heading}</p>}

							{feat.subheading && (
								<div
									dangerouslySetInnerHTML={{ __html: feat.subheading }}
									className='mb-7 mt-1'
								/>
							)}

							{feat.cta?.length > 1 &&
								feat.cta.map((cta, index) => (
									<CTA
										data={cta}
										key={index}
										className='no-underline hover:text-neutral-750 [&>span:first-child]:flex [&>span:first-child]:items-center'
									>
										<span className='decoration-1 hover:underline'>{cta.link.title}</span>
										<Icon
											name='keyboard_arrow_right'
											size={32}
										/>
									</CTA>
								))}
						</Column>
					))}

				{isValidArray(data.category?.find((cat) => cat.category_type === 'pro type')?.entries) && (
					<Column xs={4}>
						{data.category.find((cat) => cat.category_type === 'pro type').heading && <p className='mb-3 text-xl'>{data.category.find((cat) => cat.category_type === 'pro type').heading}</p>}

						<List
							bullets='none'
							className='grid grid-cols-[1fr_110px_110px_1fr] gap-8'
						>
							{data.category
								.find((cat) => cat.category_type === 'pro type')
								.entries.map((cob, index) => (
									<li key={index} className={index % 2 === 0 ? 'col-start-2' : 'col-start-3'}>
										<CTA
											data={cob}
											className='group block text-center no-underline [&>.material-symbols-sharp]:mx-auto [&>.material-symbols-sharp]:flex [&>.material-symbols-sharp]:aspect-square [&>.material-symbols-sharp]:w-[100px] [&>.material-symbols-sharp]:items-center [&>.material-symbols-sharp]:justify-center [&>.material-symbols-sharp]:rounded-full [&>.material-symbols-sharp]:bg-primary [&>.material-symbols-sharp]:!text-5xl'
										>
											{cob.link?.title && <p className='group-hover:underline text-xs/tight mt-2.5'>{cob.link.title}</p>}
										</CTA>
									</li>
								))}
						</List>
					</Column>
				)}

				{isValidArray(data?.category?.find((cat) => cat.category_type === 'resources')?.entries) && (
					<Column xs='auto'>
						{data.category?.find((cat) => cat.category_type === 'resources').heading && <p className='mb-3 text-xl'>{data.category?.find((cat) => cat.category_type === 'resources').heading}</p>}

						<List bullets='none' className='space-y-4'>
							{data.category
								?.find((cat) => cat.category_type === 'resources')
								.entries.map((link, index) => (
									<li
										key={index}
										className='leading-snug font-bold'
									>
										<CTA
											data={link}
											className='inline-block px-0 decoration-transparent decoration-1 hover:decoration-current'
										/>
									</li>
								))}
						</List>
					</Column>
				)}

				{isValidArray(data?.category?.find((cat) => cat.category_type === 'tools')?.entries) && (
					<Column xs='auto'>
						{data.category?.find((cat) => cat.category_type === 'tools').heading && <p className='mb-3 text-xl'>{data.category?.find((cat) => cat.category_type === 'tools').heading}</p>}

						<List bullets='none' className='space-y-4'>
							{data.category
								?.find((cat) => cat.category_type === 'tools')
								.entries.map((link, index) => (
									<li
										key={index}
										className='leading-snug font-bold'
									>
										<CTA
											data={link}
											className='inline-block px-0 decoration-transparent decoration-1 hover:decoration-current'
										/>
									</li>
								))}
						</List>
					</Column>
				)}
			</Row>
		</Container>
	</div>
);

ProMenu.propTypes = {
	data: PropTypes.object,
};

export default ProMenu;
